exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#_1OGhqMRiiKp810B-C-VLYh{position:fixed;top:0;left:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;z-index:1;width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"root": "_1OGhqMRiiKp810B-C-VLYh"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Bad/index.css
// module id = 472
// module chunks = 1